module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"back":"Back to home","buy":"Buy now"},"fr":{"back":"Revenir à l\u0027accueil","buy":"Acheter maintenant"}}')
  delete Component.options._Ctor
}
